import { ActionConfig } from './action-config.model';

export const ACTION_CONFIGS: ActionConfig[] = [
  { key: 'all', translationKey: 'user.table.bulk_sub_actions_label', valuePrefix: 'bulk-action' },
  { key: 'text', translationKey: 'user.table.bulk_action_type_label', valuePrefix: 'bulk-action-text' },
  { key: 'voice', translationKey: 'user.table.bulk_action_type_label', valuePrefix: 'bulk-action-voice' },
  { key: 'email', translationKey: 'user.table.bulk_action_type_label', valuePrefix: 'bulk-action-email' },
  { key: 'push', translationKey: 'user.table.bulk_action_type_label', valuePrefix: 'bulk-action-push' },
  { key: 'offer', translationKey: 'user.table.bulk_action_type_label', valuePrefix: 'bulk-action-offer' },
  { key: 'performance', translationKey: 'user.table.bulk_action_type_label', valuePrefix: 'bulk-action-performance' },
  { key: 'coachingText', translationKey: 'user.table.bulk_action_type_label', valuePrefix: 'bulk-action-text' },
  { key: 'coachingVoice', translationKey: 'user.table.bulk_action_type_label', valuePrefix: 'bulk-action-voice' },
  { key: 'coachingEmail', translationKey: 'user.table.bulk_action_type_label', valuePrefix: 'bulk-action-email' },
  { key: 'coachingPush', translationKey: 'user.table.bulk_action_type_label', valuePrefix: 'bulk-action-push' },
  { key: 'paymentEmail', translationKey: 'user.table.bulk_action_type_label', valuePrefix: 'bulk-action-email' },
  {
    key: 'paymentPush',
    translationKey: 'user.table.bulk_action_type_payment_push',
    valuePrefix: 'bulk-action-payment-push',
    labelProperty: 'bulkActionPaymentPushLabel',
  },
  { key: 'reminderEmail', translationKey: 'user.table.bulk_action_type_label', valuePrefix: 'bulk-action-email' },
  {
    key: 'reminderPush',
    translationKey: 'user.table.bulk_action_type_label',
    valuePrefix: 'bulk-action-reminder-push',
  },
  { key: 'alertRuleEmail', translationKey: 'user.table.bulk_action_type_label', valuePrefix: 'bulk-action-email' },
];
